import React from 'react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';

import ListBreaksPage from '../pages/ListBreaks/ListBreaksPage.jsx';

const Home = () => (
  <div className="home-page">
    <ListBreaksPage />
  </div>
)

export default Home;



// WEBPACK FOOTER //
// ./public/pages/Home.jsx